import Missions from './Missions';
import { connect } from 'react-redux';

const mapStateToProps = state => {
  return {
    missionsAssets: state.assetsPackage.assets.MISSIONS_FEATURE,
    assetsLoaded: state.assetsPackage.assetsLoaded,
    tutorialStep: state.tutorial.tutorialStep,
    activeTutorial: state.tutorial.activeTutorial,
    clientProgress: state.missions.currentMission.clientProgress,
    tutorialCompletedOrSkipped: state.tutorial.tutorialCompletedOrSkipped,
  };
};

export default connect(mapStateToProps)(Missions);

